import styles from './ModalActions.module.css'
import { ReactElement } from 'react'
export const ModalAction = ({items}:{items:ActionItem[]}) =>{

    return (
        <div className={styles.modal_action_container}>
            {items.map((item)=>{
            return(
                <div className={styles.modal_action_item} onClick={item.action}>
                    <img src={item.icon}/>
                    {item.name}
             </div>
            )
        })} 
        </div>

    )
}

    export interface ActionItem{
        name:string;
        icon:string;
        action:()=>void
    }